module.exports = __webpack_public_path__ + "img/close-alert.864a3169.svg";